module.exports = __webpack_public_path__ + "static/media/deaf.136203de.svg";